import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientForgotUserIDUseCase extends BaseUseCase {
    constructor(loginRepo) {
        super();
        this.loginRepo = loginRepo;
    }
    async fetchResult(data) {
        return await this.loginRepo.clientForgotUserID(data);
    }
}
export default ClientForgotUserIDUseCase;
